import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: {},

  meta: {
    errorMessage: '',
    status: '',
  },
};

const reducedRates = createSlice({
  name: 'reducedRates',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    entityJurisdictionsSuccess: (state, action) => {
      state.model = action.payload?.result;
      state.meta.status = STATUS.SUCCESS;
    },
    skuSuccess: (state, action) => {
      const {
        payload: {
          result: { entityJurisdictionId, items, rates },
        },
      } = action;

      state.model[entityJurisdictionId].items = items;
      state.model[entityJurisdictionId].rates = rates;

      state.meta.status = STATUS.SUCCESS;
    },
    create: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    createFailure: state => {
      state.meta.status = STATUS.SUCCESS;
    },
  },
});

export const {
  reset: reducedRatesReset,
  request: reducedRatesRequest,
  failure: reducedRatesFailure,
  entityJurisdictionsSuccess: reducedRatesEntityJurisdictionsSuccess,
  skuSuccess: reducedRatesSkuSuccess,
  create: reducedRatesCreate,
  createFailure: reducedRatesCreateFailure,
} = reducedRates.actions;

export default reducedRates.reducer;
